import { createFeatureSelector, createSelector } from '@ngrx/store';
import { List } from 'immutable';

import {
  ContainerPersistEditActionTypes,
  PersistAction,
} from '../../state/container-persist-edit.actions';

export const STATE_FEATURE_QUEUE = 'queue';

export interface QueueState {
  queue: List<PersistAction>;
  locked: boolean;
  etag: string;
  error: any;
}

export const QUEUE_INITIAL_STATE: QueueState = {
  queue: List(),
  locked: false,
  etag: null,
  error: null,
};

export function getInitialQueueState(): QueueState {
  return QUEUE_INITIAL_STATE;
}

export const selectQueueState =
  createFeatureSelector<QueueState>(STATE_FEATURE_QUEUE);

export const selectQueueSize = createSelector(
  selectQueueState,
  (state: QueueState) => state.queue.size,
);

export const selectQueueIsEmpty = createSelector(
  selectQueueSize,
  (size: number) => size === 0,
);

export const selectQueueError = createSelector(
  selectQueueState,
  (state: QueueState) => state.error,
);

export const selectQueueHasError = createSelector(
  selectQueueError,
  (error: any): boolean => error !== null,
);

export const selectQueueHasPublishAction = createSelector(
  selectQueueState,
  (state: QueueState) =>
    state.queue.find(
      action =>
        action.type === ContainerPersistEditActionTypes.PERSIST_PUBLISH_LIST ||
        action.type ===
          ContainerPersistEditActionTypes.PERSIST_RESUME_PUBLISH_LIST,
    ) !== undefined,
);

export const selectQueueOnlyHasPublishAction = createSelector(
  selectQueueHasPublishAction,
  selectQueueSize,
  (queueHasPublishAction, queueSize): boolean =>
    queueHasPublishAction && queueSize === 1,
);

export const selectQueueIsSafeToLeave = createSelector(
  selectQueueIsEmpty,
  selectQueueOnlyHasPublishAction,
  selectQueueHasError,
  (queueIsEmpty, queueOnlyHasPublishAction, queueHasError): boolean =>
    queueIsEmpty || queueOnlyHasPublishAction || queueHasError,
);
